import { Col, Form, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';
import {
  DirectSaleXFinancialFilterBy,
  DirectSaleXFinancialFilterDateBy,
  DirectSaleXFinancialReportType,
} from '@/core/domain/questReport/Reports/DirectSaleXFinancial/DirectSaleXFinancial.types';

const FieldFilterByDirectSale: React.FC = () => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Col sm={24}>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const filterDateBy = getFieldValue('filterDateBy');
          const reportType = getFieldValue('reportType');

          return (
            <>
              {filterDateBy === DirectSaleXFinancialFilterDateBy.financial ||
                (reportType === DirectSaleXFinancialReportType.overview && (
                  <>
                    <Title level={5}>
                      {intl.formatMessage({
                        id: 'movementDirectSaleXFinancial.form.filterDirectSalesBy',
                      })}
                    </Title>

                    <Form.Item
                      name="filterBy"
                      initialValue={DirectSaleXFinancialFilterBy.sale}
                      noStyle
                    >
                      <Radio.Group
                        optionType="button"
                        buttonStyle="solid"
                        size="large"
                      >
                        <Radio value={DirectSaleXFinancialFilterBy.sale}>
                          {intl.formatMessage({
                            id: 'movementDirectSaleXFinancial.form.filterDirectSalesBy.sale',
                          })}
                        </Radio>

                        <Radio
                          value={DirectSaleXFinancialFilterBy.authorization}
                        >
                          {intl.formatMessage({
                            id: 'movementDirectSaleXFinancial.form.filterDirectSalesBy.authorization',
                          })}
                        </Radio>
                      </Radio.Group>
                    </Form.Item>
                  </>
                ))}
            </>
          );
        }}
      </Form.Item>
    </Col>
  );
};

export default FieldFilterByDirectSale;
